import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {AuthProvider} from "./auth/AuthProvider";
import {ConfigProvider} from "antd";
import locale from 'antd/locale/en_US'

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(
    <React.StrictMode>
        <ConfigProvider locale={locale}>
            <AuthProvider>
                <App/>
            </AuthProvider>
        </ConfigProvider>
    </React.StrictMode>
);

reportWebVitals();
